import type { InteractionMetrics } from '../../common';

const interactions: Map<string, InteractionMetrics> = new Map();

export default interactions;
